import ApiRequest from '../request'

export default class ExtContactpref {
  constructor() {
    this.apiRequest = new ApiRequest()
  }
  async get(id, params = {}) {
    try {
      const res = await this.apiRequest.get(`ext_contactpref/${id}`, params)
      return res
    } catch (error) {
      return error.response
    }
  }
  async updateDigitalConsent(id, payload) {
    try {
      const res = await this.apiRequest.put(
        `ext_contactpref/${id}/digitalConsent`,
        { ...payload }
      )
      return res
    } catch (error) {
      return error.response
    }
  }
}
